//exemple de code trouver sur : https://stackoverflow.com/questions/66943220/how-to-handle-firebase-onauthstatechanged-in-a-react-app-and-route-users-accordi
import { auth } from "../Firebase";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import "./ProtectedRoute.css"
import logger from "../Components/Logger";

export function ProtectedRoute({ children}){
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const connexion = onAuthStateChanged(auth, (currentUser) => {
           setUser(currentUser)
           setIsLoading(false) 
           logger.info("Auth state changed, user: " + (currentUser ? currentUser.email : "null"));
        })
        return () => connexion();
    }, []);

    if (isLoading) {
    return (
      <div className="Placement">
        <p>Chargement de la session...</p>
      </div>
    );
  }

  if(!user){
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}